// extracted by mini-css-extract-plugin
export default {"roundWhiteCheckbox":"RoundWhiteCheckbox_roundWhiteCheckbox__-tgiy","checkmark":"RoundWhiteCheckbox_checkmark__AiYLv","labelText":"RoundWhiteCheckbox_labelText__drxWJ"};